module.exports = __webpack_public_path__ + "img/bg-header-large.38b5398.jpg";